import React, { useState } from 'react';
import BlackLogo from './images/Blacklogo';
import ChevronRight from '../../components/Images/ChevronRight';
import ChevronDown from '../../components/Images/ChevronDown';
import ImportantNoteIcon from '../../components/Images/ImportantNoteIcon';
import Certificate from './images/Certificate.png';
import CertificateLogo from './images/Certificate.webp';
import Trophy from './images/Trophy.webp';
import headPhoneWithNote from './images/headphonewithnote.svg';
import { chooseContestObject } from './contestData';
import {
  BannerContainer,
  Container,
  BannerHeadingLogo,
  BannerContent,
  BtnContainer,
  EarnBtnContainer,
  BannerButton,
  Button,
  EarnSectionButton,
  BannerHeading,
  BannerHeadingContainer,
  BannerSubHeading,
  SectionsContainer,
  SectionsCommonHeading,
  StageAndPrizeCardContainer,
  CardContainer,
  CardWrapper,
  StageCardHeading,
  StageTable,
  StageSubHeading,
  CardChevronBtn,
  FlexContainer,
  NotesPoints,
  MinWidthSetter,
  VerticalCenterItems,
  VerticalLeftItems,
  ParticipationCerticiate,
  ViewParticipationLogo,
  Rank4And5,
  Accordion,
  AccordionText,
  AccordionBtn,
  FlexContianerForStoryPoints,
  NotesFlexItem,
  BulbLogoContainer,
  TipsHeading,
  StoryWritingPoints,
  EarnBannerSection,
  EarnWriterMessage,
  EarnHeading,
  EarnSubHeading,
  StagePrizeContainer,
  Prize2and3Image,
  PrizeSubheading,
  BannerButtonContainer,
  Prizelogo,
  NotesButtonForMobile,
  NoteChangeButton,
  PrizeImg,
  SuspenseNovelsContainer,
  NovelContent,
  FaqSection,
  HeadphoneLogo,
  LiveContainer,
  Dot,
  DummyCertificateSection,
  DummyCertificateSectionForMobile,
  ExtraPadding,
  ExampleNovelImg,
  WinnerTopImg,
  WinnerH2,
  WinnerStage1,
  WinnerStage2,
  RowCard,
  CardLeft,
  CardRight,
  CardPositionImage,
  CardAuthorName,
  CardBookTitle,
  CardReward,
  CardBookCover,
  CardReadNow,
  Rank123Container,
  WinnerHeadingTitle,
  WinnerSubParaTitle,
} from './style';

import { handleEventLog, redirectToNovelLinkHandler } from '../../lib/utils';

import HeadingImg from './images/web-bg.svg';
import prize1 from './images/prize-1.svg';
import prize2 from './images/prize-2.svg';
import prize3 from './images/prize-3.svg';
import prize4 from './images/prize-4.svg';
import prize5 from './images/prize-5.svg';
import prize6 from './images/prize-6.svg';
import prize7 from './images/prize-7.svg';
import prize8 from './images/prize-8.svg';
import prize9 from './images/prize-9.svg';
import prize10 from './images/prize-10.svg';

import { useNavigate } from 'react-router-dom';

export const positionImages = [
  prize1,
  prize2,
  prize3,
  prize4,
  prize5,
  prize6,
  prize7,
  prize8,
  prize9,
  prize10,
];

const onCreateBookClick = (contestId, defaultReferrer, visibility) => {
  window.localStorage.setItem('contestId', contestId);
  handleEventLog('writer_contest', 'button_click', {
    route: window.location.pathname + window.location.search,
    button: 'join_contest_button',
  });
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const referrer = params.get('referrer') || defaultReferrer;
  if (window.localStorage.getItem('uid'))
    window.location.href = `/shows/novels/?referrer=${referrer}&open-new=1`;
  else
    window.location.href = `/${visibility === 'row' ? 'globalLogin' : ''}?referrer=${referrer}`;
};

const handleEarnButtonClick = (contestId, defaultReferrer, visibility) => {
  if (visibility === 'row') {
    window.location.href = `/author-welfare-global`;
  } else if (visibility === 'india') {
    window.location.href = `/author-welfare/hindi`;
  } else {
    onCreateBookClick(contestId, defaultReferrer, visibility);
  }
};
const toggleExtraInfoHandler = (e) => {
  const extraInfoElement = e.currentTarget.previousElementSibling;
  if (
    extraInfoElement.style.maxHeight !== `${extraInfoElement.scrollHeight}px`
  ) {
    extraInfoElement.style.maxHeight = `${extraInfoElement.scrollHeight}px`;
    extraInfoElement.style.webkitTextFillColor = `var(--Text500)`;
  } else {
    extraInfoElement.style.maxHeight = '6rem';
    extraInfoElement.style.webkitTextFillColor = `transparent`;
  }
  e.currentTarget.classList.toggle('open');
};

const toggleAccordionTextHandler = (e) => {
  const accordionTextElement = e.currentTarget.nextElementSibling;
  if (accordionTextElement.style.maxHeight)
    accordionTextElement.style.maxHeight = null;
  else
    accordionTextElement.style.maxHeight = `${accordionTextElement.scrollHeight}px`;
  e.currentTarget.classList.toggle('open');
};

const showNovelHandler = (novelId) => {
  redirectToNovelLinkHandler(novelId);
};

const WinnersPageStatusLog = [
  {
    Name: 'rahasyamay-prem',
    isWinnersPageLive: true,
    isStage2WinnersLive: true,
    isWinnersPageLiveText: false,
  },
  {
    Name: 'sci-fiction',
    isWinnersPageLive: true,
    isStage2WinnersLive: true,
    isWinnersPageLiveText: false,
  },
  {
    Name: 'romance-and-paranormal-romance',
    isWinnersPageLive: true,
    isStage2WinnersLive: false,
    isWinnersPageLiveText: true,
  },
  {
    Name: 'campus-diaries',
    isWinnersPageLive: false,
    isStage2WinnersLive: false,
    isWinnersPageLiveText: false,
  },
  {
    Name: 'campus-diaries-hindi',
    isWinnersPageLive: false,
    isStage2WinnersLive: false,
    isWinnersPageLiveText: false,
  },
  {
    Name: 'campus-diaries-tamil',
    isWinnersPageLive: false,
    isStage2WinnersLive: false,
    isWinnersPageLiveText: false,
  },
];

const Template1 = ({ title, ...props }) => {
  const isMobile = window.innerWidth <= 770;
  const { isWinnersPageLive } = WinnersPageStatusLog.find(
    (contest) => contest.Name === title
  );
  const { isStage2WinnersLive } = WinnersPageStatusLog.find(
    (contest) => contest.Name === title
  );
  const { isWinnersPageLiveText } = WinnersPageStatusLog.find(
    (contest) => contest.Name === title
  );
  const [currentNotePoint, setCurrentNotePoint] = useState(1);
  const [toggleViewCertificate, setToggleViewCertificate] = useState(false);
  const [activeTab, setActiveTab] = useState('winner');
  const navigate = useNavigate();
  if (!chooseContestObject[title]) {
    navigate('/contest');
    return null;
  }
  const {
    storyPoints,
    StageContent,
    exampleNovels,
    FAQs,
    constants,
    WinnersStage1,
    WinnersStage2,
    WinnersStageText,
  } = chooseContestObject[title];
  const handleViewCertificate = () => {
    setToggleViewCertificate(!toggleViewCertificate);
  };

  return (
    <Container>
      <BannerContainer
        BannerDesktopImage={constants.BannerDesktopImage}
        BannerMobileImage={constants.BannerMobileImage}
      >
        <BannerContent>
          <BannerHeadingLogo>
            <BlackLogo />
          </BannerHeadingLogo>
          <BannerHeadingContainer>
            <BannerHeading>
              {constants.heading}
              <br />
            </BannerHeading>
            <BannerSubHeading>{constants.subHeading}</BannerSubHeading>
          </BannerHeadingContainer>
          {(isWinnersPageLive || constants.contestId) && (
            <BannerButtonContainer>
              {!isWinnersPageLive && (
                <BannerButton
                  onClick={() =>
                    onCreateBookClick(
                      constants.contestId,
                      constants.defaultReferrer,
                      constants.visibility
                    )
                  }
                  activeTabColor
                >
                  {constants.bannerButton}
                </BannerButton>
              )}
              {isWinnersPageLive && (
                <BannerButton
                  onClick={() => setActiveTab('detail')}
                  activeTabColor={activeTab === 'detail'}
                >
                  {' '}
                  Contest Details{' '}
                </BannerButton>
              )}
              {isWinnersPageLive && (
                <BannerButton
                  onClick={() => setActiveTab('winner')}
                  activeTabColor={activeTab === 'winner'}
                >
                  {' '}
                  Winners{' '}
                </BannerButton>
              )}
            </BannerButtonContainer>
          )}
        </BannerContent>
      </BannerContainer>
      {(activeTab === 'detail' || !isWinnersPageLive) && (
        <SectionsContainer>
          <ExtraPadding>
            <section>
              <SectionsCommonHeading>
                {' '}
                {constants.section_1_Heading}{' '}
              </SectionsCommonHeading>
              <StageAndPrizeCardContainer>
                {StageContent.map((data, index) => {
                  const {
                    bgColor,
                    headingbgColor,
                    stageheading,
                    stageSubHeading,
                    tableContent,
                    stageContent,
                    prizeHeading,
                    firstPrize,
                    secondPrize,
                    thirdPrize,
                    rank4And5Prize,
                    isLive,
                    rank1Prize,
                    rank2Prize,
                    rank3Prize,
                    lowerRankCombinedPrizeTitle,
                  } = data;
                  return (
                    <div key={index}>
                      {' '}
                      <CardContainer backgroundColor={bgColor}>
                        <CardWrapper>
                          <StageCardHeading backgroundColor={headingbgColor}>
                            {stageheading}{' '}
                          </StageCardHeading>
                          <StageSubHeading>
                            {stageSubHeading}
                            <LiveContainer
                              color={isLive ? '#54b585' : 'var(--Punch500)'}
                            >
                              {' '}
                              <Dot
                                bgColor={isLive ? '#54b585' : 'var(--Punch500)'}
                              />
                              &nbsp;{isLive ? 'LIVE' : 'ENDED'}
                            </LiveContainer>
                          </StageSubHeading>
                          <StageTable>
                            <tbody>
                              {tableContent.map((content, i) => (
                                <tr key={i}>
                                  <td>
                                    {content.title}
                                    <span role="img">{content.img}</span>
                                  </td>
                                  <td>{content.date}</td>
                                </tr>
                              ))}
                            </tbody>
                          </StageTable>

                          <FlexContainer>
                            <MinWidthSetter>
                              <ImportantNoteIcon width="34" height="34" />
                            </MinWidthSetter>
                            <div>
                              <NotesPoints>{stageContent}</NotesPoints>
                              <CardChevronBtn onClick={toggleExtraInfoHandler}>
                                <ChevronDown
                                  width="24"
                                  height="24"
                                  fillOpacity="1"
                                />
                              </CardChevronBtn>
                            </div>
                          </FlexContainer>
                        </CardWrapper>
                        <VerticalCenterItems>
                          {firstPrize && (
                            <StagePrizeContainer>
                              <PrizeImg>
                                <img src={firstPrize} alt="" />
                              </PrizeImg>
                            </StagePrizeContainer>
                          )}
                          {secondPrize && (
                            <StagePrizeContainer>
                              <Prize2and3Image src={secondPrize} />
                              <Prize2and3Image src={thirdPrize} />
                            </StagePrizeContainer>
                          )}
                          {rank1Prize && (
                            <>
                              <Rank123Container>
                                <Prizelogo src={Trophy} />
                                {lowerRankCombinedPrizeTitle || <>Rank 1 - </>}
                                <span role="img">💸</span> {rank1Prize}
                              </Rank123Container>
                              <Rank123Container>
                                <Prizelogo src={Trophy} />
                                {lowerRankCombinedPrizeTitle || <>Rank 2 - </>}
                                <span role="img">💸</span> {rank2Prize}
                              </Rank123Container>
                              <Rank123Container>
                                <Prizelogo src={Trophy} />
                                {lowerRankCombinedPrizeTitle || <>Rank 3 - </>}
                                <span role="img">💸</span> {rank3Prize}
                              </Rank123Container>
                            </>
                          )}
                          <Rank4And5>
                            <Prizelogo src={Trophy} />
                            {lowerRankCombinedPrizeTitle || (
                              <>Rank 4th & 5th - </>
                            )}
                            <span role="img">💸</span> {rank4And5Prize} each
                          </Rank4And5>
                          {constants.showCertificateLink && (
                            <ParticipationCerticiate
                              href={constants.participation_certificate_image}
                              download="certificate"
                              onClick={() => handleViewCertificate()}
                            >
                              {' '}
                              <ViewParticipationLogo
                                src={CertificateLogo}
                              />{' '}
                              View Participation Certificate
                            </ParticipationCerticiate>
                          )}
                          {toggleViewCertificate && (
                            <DummyCertificateSectionForMobile>
                              <SectionsCommonHeading>
                                {constants.section_2_Heading}
                              </SectionsCommonHeading>
                              <img src={Certificate} width="100%" alt="" />
                            </DummyCertificateSectionForMobile>
                          )}
                          {constants.stageButton && (
                            <BtnContainer>
                              <Button
                                onClick={() =>
                                  onCreateBookClick(
                                    constants.contestId,
                                    constants.defaultReferrer,
                                    constants.visibility
                                  )
                                }
                              >
                                {constants.stageButton}
                              </Button>
                            </BtnContainer>
                          )}
                        </VerticalCenterItems>
                      </CardContainer>
                      {prizeHeading && (
                        <>
                          {' '}
                          <PrizeSubheading>
                            {constants.prizeSubheading}
                            <HeadphoneLogo src={headPhoneWithNote} />
                          </PrizeSubheading>
                        </>
                      )}
                    </div>
                  );
                })}
              </StageAndPrizeCardContainer>
            </section>
            {constants.showCertifiicateImg && (
              <DummyCertificateSection>
                <SectionsCommonHeading>
                  {constants.section_2_Heading}
                </SectionsCommonHeading>
                <img src={Certificate} width="100%" alt="" />
              </DummyCertificateSection>
            )}
            <section>
              <SectionsCommonHeading>
                {constants.section_3_Heading}
              </SectionsCommonHeading>
              <SuspenseNovelsContainer>
                {exampleNovels.map((novel, index) => (
                  <NovelContent key={index}>
                    <ExampleNovelImg
                      src={novel.novelImgLink}
                      alt={novel.title}
                    />
                    <Button onClick={() => showNovelHandler(novel.novelId)}>
                      {constants.novelContent}
                    </Button>
                  </NovelContent>
                ))}
              </SuspenseNovelsContainer>
            </section>

            <section>
              <SectionsCommonHeading>
                {constants.section_4_Heading}
              </SectionsCommonHeading>
              <FlexContianerForStoryPoints>
                {storyPoints.map((data) => {
                  const display =
                    data.key === currentNotePoint ? 'block' : 'none';
                  return (
                    <NotesFlexItem key={data.key} display={display}>
                      <BulbLogoContainer>
                        <ImportantNoteIcon />
                      </BulbLogoContainer>
                      <TipsHeading>TIP {data.key}</TipsHeading>
                      <StoryWritingPoints> {data.point}</StoryWritingPoints>
                    </NotesFlexItem>
                  );
                })}
              </FlexContianerForStoryPoints>
              <NotesButtonForMobile>
                {storyPoints.map((data, index) => (
                  <NoteChangeButton
                    key={index}
                    onClick={() => setCurrentNotePoint(data.key)}
                    isActive={data.key === currentNotePoint}
                    data={index}
                  >
                    {data.key}
                  </NoteChangeButton>
                ))}
              </NotesButtonForMobile>
            </section>
          </ExtraPadding>

          <EarnBannerSection>
            <EarnWriterMessage>
              After completion of 30K words you can enter into the Writer’s
              Benefit Program
            </EarnWriterMessage>
            <VerticalLeftItems>
              <EarnHeading color="#FFFFFF">{constants.earnHeading}</EarnHeading>
              <EarnSubHeading>{constants.earnSubheading}</EarnSubHeading>
            </VerticalLeftItems>
            {constants.contestId && (
              <EarnBtnContainer>
                <EarnSectionButton
                  onClick={() =>
                    handleEarnButtonClick(
                      constants.contestId,
                      constants.defaultReferrer,
                      constants.visibility
                    )
                  }
                >
                  {constants.earnSectionButton}
                  <ChevronRight fillOpacity="1" />
                </EarnSectionButton>
              </EarnBtnContainer>
            )}
          </EarnBannerSection>

          <ExtraPadding>
            <FaqSection>
              <SectionsCommonHeading>
                {constants.section_5_Heading}
              </SectionsCommonHeading>
              {FAQs.map((faq, index) => (
                <Accordion key={index}>
                  <AccordionBtn onClick={toggleAccordionTextHandler}>
                    {faq.question}
                  </AccordionBtn>
                  <AccordionText>{faq.answer}</AccordionText>
                </Accordion>
              ))}
            </FaqSection>
          </ExtraPadding>
        </SectionsContainer>
      )}
      {isWinnersPageLive && activeTab === 'winner' && !isMobile && (
        <SectionsContainer transform={constants.visibility !== 'row'}>
          {constants.visibility !== 'row' && (
            <WinnerTopImg src={HeadingImg} alt="" />
          )}
          {!isWinnersPageLiveText ? <WinnerH2>STAGE 1</WinnerH2> : null}
          {isWinnersPageLiveText ? (
            <>
              <WinnerH2>{WinnersStageText.headingTitle}</WinnerH2>
              <WinnerHeadingTitle>
                {WinnersStageText.subHeadingTitle}
              </WinnerHeadingTitle>
              <WinnerH2>{WinnersStageText.topNovels}</WinnerH2>
            </>
          ) : null}
          <WinnerStage1>
            {WinnersStage1.map((Winner, index) => (
              <RowCard key={index}>
                <CardLeft>
                  <CardPositionImage src={positionImages[index]} alt="1" />
                  <CardAuthorName>{Winner.AuthorName}</CardAuthorName>
                  <CardBookTitle>{Winner.NovelTitle}</CardBookTitle>
                  <CardReward>Reward : {Winner.Reward}</CardReward>
                </CardLeft>
                <CardRight>
                  <CardBookCover src={Winner.ImageUrl} alt="1" />
                  <CardReadNow onClick={() => showNovelHandler(Winner.id)}>
                    READ NOW
                  </CardReadNow>
                </CardRight>
              </RowCard>
            ))}
          </WinnerStage1>
          {isWinnersPageLiveText ? (
            <>
              <WinnerHeadingTitle>
                {WinnersStageText.paraTitle}
              </WinnerHeadingTitle>
              <WinnerSubParaTitle>
                {WinnersStageText.subParaTitle}
              </WinnerSubParaTitle>
            </>
          ) : null}
          {!isWinnersPageLiveText && !isStage2WinnersLive && (
            <WinnerH2>🏆: STAGE 2 winners are yet to be announced</WinnerH2>
          )}
          {isStage2WinnersLive && (
            <>
              {!isWinnersPageLiveText ? <WinnerH2>STAGE 2</WinnerH2> : null}
              <WinnerStage2>
                {WinnersStage2.map((Winner, index) => (
                  <RowCard key={index}>
                    <CardLeft>
                      <CardPositionImage src={positionImages[index]} alt="1" />
                      <CardAuthorName>{Winner.AuthorName}</CardAuthorName>
                      <CardBookTitle>{Winner.NovelTitle}</CardBookTitle>
                      <CardReward>Reward : {Winner.Reward}</CardReward>
                    </CardLeft>
                    <CardRight>
                      <CardBookCover src={Winner.ImageUrl} alt="1" />
                      <CardReadNow onClick={() => showNovelHandler(Winner.id)}>
                        READ NOW
                      </CardReadNow>
                    </CardRight>
                  </RowCard>
                ))}
              </WinnerStage2>
            </>
          )}
        </SectionsContainer>
      )}
      {isWinnersPageLive && activeTab === 'winner' && isMobile && (
        <>
          <SectionsContainer transform={constants.visibility !== 'row'}>
            {constants.visibility !== 'row' && (
              <WinnerTopImg src={HeadingImg} alt="" />
            )}
            {!isWinnersPageLiveText ? <WinnerH2>STAGE 1</WinnerH2> : null}
            {isWinnersPageLiveText ? (
              <>
                <WinnerH2>{WinnersStageText.headingTitle}</WinnerH2>
                <WinnerHeadingTitle>
                  {WinnersStageText.subHeadingTitle}
                </WinnerHeadingTitle>
                <WinnerH2>{WinnersStageText.topNovels}</WinnerH2>
              </>
            ) : null}
            <WinnerStage1>
              {WinnersStage1.map((Winner, index) => (
                <RowCard key={index}>
                  <CardLeft>
                    <CardPositionImage src={positionImages[index]} alt="1" />
                    <CardAuthorName>{Winner.AuthorName}</CardAuthorName>
                    <CardBookTitle>{Winner.NovelTitle}</CardBookTitle>
                    <CardReward>Reward : {Winner.Reward}</CardReward>
                  </CardLeft>
                  <CardRight>
                    <CardBookCover src={Winner.ImageUrl} alt="1" />
                    <CardReadNow onClick={() => showNovelHandler(Winner.id)}>
                      READ
                    </CardReadNow>
                  </CardRight>
                </RowCard>
              ))}
            </WinnerStage1>
            {isWinnersPageLiveText ? (
              <>
                <WinnerHeadingTitle>
                  {WinnersStageText.paraTitle}
                </WinnerHeadingTitle>
                <WinnerSubParaTitle>
                  {WinnersStageText.subParaTitle}
                </WinnerSubParaTitle>
              </>
            ) : null}
            {!isWinnersPageLiveText && !isStage2WinnersLive && (
              <WinnerH2>🏆: STAGE 2 winners are yet to be announced</WinnerH2>
            )}
            {isStage2WinnersLive && (
              <>
                {!isWinnersPageLiveText ? <WinnerH2>STAGE 2</WinnerH2> : null}
                <WinnerStage2>
                  {WinnersStage2.map((Winner, index) => (
                    <RowCard key={index}>
                      <CardLeft>
                        <CardPositionImage
                          src={positionImages[index]}
                          alt="1"
                        />
                        <CardAuthorName>{Winner.AuthorName}</CardAuthorName>
                        <CardBookTitle>{Winner.NovelTitle}</CardBookTitle>
                        <CardReward>Reward : {Winner.Reward}</CardReward>
                      </CardLeft>
                      <CardRight>
                        <CardBookCover src={Winner.ImageUrl} alt="1" />
                        <CardReadNow
                          onClick={() => showNovelHandler(Winner.id)}
                        >
                          READ
                        </CardReadNow>
                      </CardRight>
                    </RowCard>
                  ))}
                </WinnerStage2>
              </>
            )}
          </SectionsContainer>
        </>
      )}
    </Container>
  );
};

export default Template1;
